import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import equipmentGroupsAtom from '../../atoms/equipmentGroups.atom.ts'
import eventBus from '../../../../services/eventBus'
import recoilStateUpdaters from '../../../../recoil/recoil.stateUpdaters.ts'

const useEquipmentGroupsEventsSubscriptions = () => {
  const setGroupsState = useSetRecoilState(equipmentGroupsAtom)

  useEffect(() => {
    const createSub = eventBus.sub('equipment.group.created', (group) => {
      recoilStateUpdaters.itemCreated(setGroupsState, group)
    })

    const updateSub = eventBus.sub('equipment.group.updated', (group) => {
      recoilStateUpdaters.itemUpdated(setGroupsState, group)
    })

    const removeSub = eventBus.sub('equipment.group.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setGroupsState, id)
    })

    return () => {
      createSub()
      updateSub()
      removeSub()
    }
  }, [])
}

export default useEquipmentGroupsEventsSubscriptions
